import { utilsForUser } from '@tencent/wuji-utils';
import * as yaml from 'js-yaml';
import * as marked from 'marked';
import * as pako from 'pako';
export const platformBuiltinModules = {
    axios: () => utilsForUser.axios,
    lodash: () => utilsForUser.lodash,
    dayjs: () => utilsForUser.dayjs,
    ajv: () => utilsForUser.ajv,
    'crypto-js': () => utilsForUser.crypto,
    'js-yaml': () => yaml,
    marked: () => marked,
    pako: () => pako,
};
